import { createSelector } from '@reduxjs/toolkit';
import { getProfile } from './getProfile';

export const getTimezone = createSelector(getProfile, (profile) => profile?.timeZone);
